import { FormBase } from "core/components";

export default class FacilityOrderTemplateNewFlowCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "subCategoryId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.SUB_CATEGORY_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.SUB_CATEGORY_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "portalNote",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_PLACEHOLDER",
                    rules: "string"
                }
            ],
        };
    }
}